import WebpackerReact from "webpacker-react";
import { NotesPanel } from "n2-styles";
import StoreProductAnnotations from "../react/annotations/StoreProductAnnotations";
import SwipeCarouselNavigation from "../components/SwipeCarouselNavigation";
import { SetupResolvedHandler, KeydownListener } from "../components/AnnotationViewHelpers";

export default class StoreCustomLabelsAnnotations {
  constructor(params) {
    this.params = params;
  }

  unload() {
    StoreProductAnnotations.unload();
  }

  index() {
    // unload here in event user pushed back in browser
    StoreProductAnnotations.unload();
    const page = this.params.page || 1;
    if ($("img.js-annotation-boundry").length) {
      const img = new Image();
      img.src = $("img.js-annotation-boundry")[0].src;
      img.onload = () => {
        this.initView(page);
      };
    } else if (!$(".js-no-finished-asset").length) {
      this.initView(page);
    }
    if (!$(".js-no-finished-asset").length) {
      new SwipeCarouselNavigation();
    }
    WebpackerReact.setup({ NotesPanel });
  }

  initView(page) {
    this.storeProductAnnotations = StoreProductAnnotations.init(page);
    KeydownListener();
    SetupResolvedHandler(this.storeProductAnnotations.annotations, this.params.currentAnnotation);
  }
}
